import { useState, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CustomCard from "components/common/CustomCard";
import CardBody from "components/common/CardBody";
import { BsInfoCircleFill } from "react-icons/bs";
import { GoAlertFill } from "react-icons/go";
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import DatePickerCustom2 from "components/DatePickerCustom2";
import { MdDone } from "react-icons/md";
import DatePickerCustom from "components/DatePickerCustom";
import Column from "components/common/Column";
import { Card } from "react-bootstrap";
import Row from "components/common/Row";
import { displayNotification, sendAPIRequest } from "helpers";

const missionModalityOptions = [
  { label: "Face-to-Face", value: "face-to-face" },
  { label: "Virtual", value: "remote_modality" },
  { label: "Mixed Modality", value: "mixed_modality" },
];

const missionStatusChangeoption = [
  { id: 0, label: "Cancelled", value: "cancelled" },
  // { id: 1, label: "Completed", value: "completed" },
  // { id: 2, label: "In Progress", value: "in-progress" },
  { id: 3, label: "On Hold", value: "on-hold" },
];

export default function MissionChangeTabs() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [securityStatusChange, setSecurityStatusChange] = useState("no");
  const [missionModality, setMissionModality] = useState("no");
  const [missionDate, setMissionDate] = useState("no");
  const [expertChange, setExpertChange] = useState("no");
  const [missionStatusChange, setMissionStatusChange] = useState("no");
  const [specificContentChange, setSpecificContentChange] = useState("no");
  const [filters, setFilters] = useState({ area: [] });

  const navigationFunction = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const areaOptions = [
    { id: 0, value: "PPR", label: "PPR" },
    { id: 1, value: "ASF", label: "ASF" },
    { id: 2, value: "Rabies", label: "Rabies" },
  ];

  const reopenFormByKey = async (key) => {
    try {
      const ret = await sendAPIRequest(
        `/api/pvsa/movement/reopen-form-by-key/${id}/${key}`
      );

      const res = await ret.json();

      if (res.success) {
        displayNotification("success", "Form reopen Successfully");
      } 
    } catch (e) {
      displayNotification("warning", e);
    }
  };

  return (
    <div className="">
      <Row>
        <Column className="py-2" col={12}>
          <>
            <Card
              className={`card-border p-5 rounded-0 h-100`}
              // style={{ backgroundColor: "#F2F2F2" }}
              style={{ backgroundColor: "#f2f2f287" }}
            >
              <h2>
                {" "}
                1. Would you like to change the mission’s Security Status?
              </h2>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel
                    value="yes"
                    checked={securityStatusChange === "yes"}
                    onClick={() => {
                      setSecurityStatusChange("yes");
                    }}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="no"
                    checked={securityStatusChange === "no"}
                    onClick={() => {
                      setSecurityStatusChange("no");
                    }}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
              {securityStatusChange === "yes" && (
                <>
                  <div className="pt-1">
                    <CustomCard
                      className="shadow-sm"
                      style={{ backgroundColor: "#F8F3D5" }}
                    >
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <GoAlertFill
                            className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                            size={24}
                          />
                          <div
                            className="alert my-0 py-0 me-5 rounded-0 text-dark d-flex align-items-center"
                            style={{ backgroundColor: "#F8F3D5" }}
                            role="alert"
                          >
                            <div className="fs-4 text-justify me-0">
                              Upon submitting this change, the Security Form
                              will be reopened, allowing you to re-enter a new
                              Security Status. You may find this reopened form
                              under the “My Tasks” tab of the Mission Tasks.
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </CustomCard>
                  </div>
                  <div className="pt-1">
                    <CustomCard className="shadow-sm bg-light">
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <BsInfoCircleFill
                            className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                            size={24}
                          />
                          <div
                            className="alert my-0 py-0 me-5 rounded-0 bg-light text-dark d-flex align-items-center"
                            role="alert"
                          >
                            <div className="fs-4 text-justify me-0">
                              Please consider if the mission status, mission
                              dates or mission modality may also be impacted as
                              a result of a change to the security status.
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </CustomCard>
                  </div>
                </>
              )}
            </Card>
          </>
        </Column>
        <Column className="py-2" col={12}>
          <Card
            className={`card-border p-5 rounded-0 h-100`}
            style={{ backgroundColor: "#f2f2f287" }}
          >
            <h2>2. Would you like to change the Mission Modality?</h2>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel
                  value="yes"
                  checked={missionModality === "yes"}
                  onClick={() => {
                    setMissionModality("yes");
                  }}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="no"
                  checked={missionModality === "no"}
                  onClick={() => {
                    setMissionModality("no");
                  }}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
            {missionModality === "yes" && (
              <>
                <div className="row ms-2">
                  <div className="col-md-8">
                    <AutoCompleteDropdown
                      required={false}
                      error={false}
                      options={missionModalityOptions}
                      label={"Enter New Mission Modality"}
                      multiple={false}
                      hasselectall={false}
                      overflowY={"hidden"}
                    />
                  </div>
                </div>
                <div className="pt-1">
                  <CustomCard
                    className="shadow-sm"
                    style={{ backgroundColor: "#F8F3D5" }}
                  >
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <GoAlertFill
                          className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                          size={24}
                        />
                        <div
                          className="alert my-0 py-0 me-5 rounded-0 text-dark d-flex align-items-center"
                          style={{ backgroundColor: "#F8F3D5" }}
                          role="alert"
                        >
                          <div className="fs-4 text-justify me-0">
                            Upon submitting this change, the Mission Proposal
                            Letter and Proposal Acceptance Form will be
                            reopened, allowing you to update and regenerate the
                            letter for the delegate. You may find this reopened
                            letter and Form under the “My Tasks” tab of the
                            Mission Tasks.{" "}
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </CustomCard>
                </div>
                <div className="pt-1">
                  <CustomCard className="shadow-sm bg-light">
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <BsInfoCircleFill
                          className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                          size={24}
                        />
                        <div
                          className="alert my-0 py-0 me-5 rounded-0 bg-light text-dark d-flex align-items-center"
                          role="alert"
                        >
                          <div className="fs-4 text-justify me-0">
                            Please consider if the mission dates or expert team
                            may also be impacted as a result of a change to the
                            mission modality.{" "}
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </CustomCard>
                </div>
              </>
            )}
          </Card>
        </Column>
        <Column className="py-2" col={12}>
          <Card
            className={`p-5 card-border rounded-0 h-100`}
            style={{ backgroundColor: "#f2f2f287" }}
          >
            <h2>3. Would you like to change the Mission Dates?</h2>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel
                  value="yes"
                  checked={missionDate === "yes"}
                  onClick={() => {
                    setMissionDate("yes");
                  }}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="no"
                  checked={missionDate === "no"}
                  onClick={() => {
                    setMissionDate("no");
                  }}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
            {missionDate === "yes" && (
              <>
                <div className="row px-2">
                  <h5>New Mission Dates</h5>
                  <div className="col-md-6 pb-1">
                    <DatePickerCustom
                      label={t("-1", "Start Date")}
                      // value={
                      //   dayjs(form.mission_preferred)
                      // }
                      // onChange={(value) =>
                      //   setForm({ ...form, mission_preferred: value })
                      // }
                      slotProps={{
                        textField: {
                          size: "small",
                          inputProps: { readOnly: true },
                        },
                      }}
                      sx={{ width: "100%" }}
                      error={false}
                      // disabled={id ? true : false}
                      // minDate={dayjs()}
                    />
                  </div>
                  <div className="col-md-6 pb-1">
                    <DatePickerCustom
                      label={t("-1", "End Date")}
                      // value={
                      //   dayjs(form.mission_preferred)
                      // }
                      // onChange={(value) =>
                      //   setForm({ ...form, mission_preferred: value })
                      // }
                      slotProps={{
                        textField: {
                          size: "small",
                          inputProps: { readOnly: true },
                        },
                      }}
                      sx={{ width: "100%" }}
                      error={false}
                      // disabled={id ? true : false}
                      // minDate={dayjs()}
                    />
                  </div>
                </div>
                <div className="pt-1">
                  <CustomCard
                    className="shadow-sm"
                    style={{ backgroundColor: "#F8F3D5" }}
                  >
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <GoAlertFill
                          className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                          size={24}
                        />
                        <div
                          className="alert my-0 py-0 me-5 rounded-0 text-dark d-flex align-items-center"
                          style={{ backgroundColor: "#F8F3D5" }}
                          role="alert"
                        >
                          <div className="fs-4 text-justify me-0">
                            Upon submitting this change, the Mission Proposal
                            Letter and Proposal Acceptance Form will be
                            reopened, allowing you to update and regenerate the
                            letter for the delegate. You may find this reopened
                            letter and Form under the “My Tasks” tab of the
                            Mission Tasks.{" "}
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </CustomCard>
                </div>
                <div className="pt-1">
                  <CustomCard className="shadow-sm bg-light">
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <BsInfoCircleFill
                          className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                          size={24}
                        />
                        <div
                          className="alert my-0 py-0 me-5 rounded-0 bg-light text-dark d-flex align-items-center"
                          role="alert"
                        >
                          <div className="fs-4 text-justify me-0">
                            Please check if the current expert team is still
                            available for the new mission dates.{" "}
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </CustomCard>
                </div>
              </>
            )}
          </Card>
        </Column>
        <Column className="py-2" col={12}>
          <Card
            className={`p-5 card-border rounded-0 h-100`}
            style={{ backgroundColor: "#f2f2f287" }}
          >
            <h2>
              4. Would you like to change the Expert Team on this mission?
            </h2>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel
                  value="yes"
                  checked={expertChange === "yes"}
                  onClick={() => {
                    setExpertChange("yes");
                  }}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="no"
                  checked={expertChange === "no"}
                  onClick={() => {
                    setExpertChange("no");
                  }}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
            {expertChange === "yes" && (
              <>
                <div className="pt-1">
                  <CustomCard
                    className="shadow-sm"
                    style={{ backgroundColor: "#F8F3D5" }}
                  >
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <GoAlertFill
                          className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                          size={24}
                        />
                        <div
                          className="alert my-0 py-0 me-5 rounded-0 text-dark d-flex align-items-center"
                          style={{ backgroundColor: "#F8F3D5" }}
                          role="alert"
                        >
                          <div className="fs-4 text-justify me-0">
                            Upon submitting this change, the Expert Team
                            Selection form will be reopened, allowing you to
                            edit the expert team. The Mission Proposal Letter
                            and Proposal Acceptance Form will also be reopened,
                            allowing you to update and regenerate the letter for
                            the delegate. You may find these reopened forms
                            under the “My Tasks” tab of the Mission Tasks.
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </CustomCard>
                </div>
                <div className="pt-1">
                  <CustomCard className="shadow-sm bg-light">
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <BsInfoCircleFill
                          className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                          size={24}
                        />
                        <div
                          className="alert my-0 py-0 me-5 rounded-0 bg-light text-dark d-flex align-items-center"
                          role="alert"
                        >
                          <div className="fs-4 text-justify me-0">
                            Please check if the updated expert team is still
                            available for the existing mission dates
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </CustomCard>
                </div>
              </>
            )}
          </Card>
        </Column>
        <Column className="py-2" col={12}>
          <Card
            className={`p-5 card-border rounded-0 h-100`}
            style={{ backgroundColor: "#f2f2f287" }}
          >
            <h2>5. Would you like to change the Mission Status?</h2>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel
                  value="yes"
                  checked={missionStatusChange === "yes"}
                  onClick={() => {
                    setMissionStatusChange("yes");
                  }}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="no"
                  checked={missionStatusChange === "no"}
                  onClick={() => {
                    setMissionStatusChange("no");
                  }}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
            {missionStatusChange === "yes" && (
              <>
                <div className="row ms-2">
                  <div className="col-md-6">
                    <AutoCompleteDropdown
                      required={false}
                      error={false}
                      options={missionStatusChangeoption}
                      label={"Enter New Mission Status"}
                      multiple={false}
                      hasselectall={false}
                      overflowY={"hidden"}
                    />
                  </div>
                </div>
                <div className="pt-1">
                  <CustomCard className="shadow-sm bg-light">
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <BsInfoCircleFill
                          className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                          size={24}
                        />
                        <div
                          className="alert my-0 py-0 me-5 rounded-0 bg-light text-dark d-flex align-items-center"
                          role="alert"
                        >
                          <div className="fs-4 text-justify me-0">
                            If the mission needs to be put on-hold, please
                            assess if the impact is long term or short term. If
                            the impact is long term and has no foreseeable
                            outcome in the near future, please cancel the
                            mission and re-open a new one if required later on.
                            Please only place a mission on hold if it can be
                            resumed in the short-term
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </CustomCard>
                </div>
              </>
            )}
          </Card>
        </Column>
        <Column className="py-2" col={12}>
          <Card
            className={`p-5 card-border rounded-0 h-100`}
            style={{ backgroundColor: "#f2f2f287" }}
          >
            <h2>
              6. Do you want to change or add specific content to this mission?
            </h2>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel
                  value="yes"
                  checked={specificContentChange === "yes"}
                  onClick={() => {
                    setSpecificContentChange("yes");
                  }}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="no"
                  checked={specificContentChange === "no"}
                  onClick={() => {
                    setSpecificContentChange("no");
                  }}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
            {specificContentChange === "yes" && (
              <>
                <div className="row ms-2">
                  <div className="col-md-6">
                    <AutoCompleteDropdown
                      error={false}
                      required={false}
                      label="Specific Content"
                      multiple={true}
                      hasselectall={true}
                      options={areaOptions}
                      onChange={(event, value) => {
                        if (value.some((v) => v.value === "Select all")) {
                          const isAllSelected =
                            filters.area.length === areaOptions.length;
                          navigationFunction(
                            "area",
                            isAllSelected ? [] : areaOptions.map((r) => r.value)
                          );
                        } else {
                          navigationFunction(
                            "area",
                            value.map((r) => r.value)
                          );
                        }
                      }}
                      value={filters.area}
                    />
                  </div>
                </div>
                <div className="pt-1">
                  <CustomCard
                    className="shadow-sm"
                    style={{ backgroundColor: "#F8F3D5" }}
                  >
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <GoAlertFill
                          className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                          size={24}
                        />
                        <div
                          className="alert my-0 py-0 me-5 rounded-0 text-dark d-flex align-items-center"
                          style={{ backgroundColor: "#F8F3D5" }}
                          role="alert"
                        >
                          <div className="fs-4 text-justify me-0">
                            Upon submitting this change, the Mission Proposal
                            Letter and Proposal Acceptance Form will be
                            reopened, allowing you to update and regenerate the
                            letter for the delegate. You may find this reopened
                            letter under the “My Tasks” tab of the Mission
                            Tasks.
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </CustomCard>
                </div>
                <div className="pt-1">
                  <CustomCard className="shadow-sm bg-light">
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <BsInfoCircleFill
                          className="bi flex-shrink-0 me-4 ms-3 mb-auto  cursor-pointer"
                          size={24}
                        />
                        <div
                          className="alert my-0 py-0 me-5 rounded-0 bg-light text-dark d-flex align-items-center"
                          role="alert"
                        >
                          <div className="fs-4 text-justify me-0">
                            Please check if the current expert team is still
                            suitable for the specific content of this mission.
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </CustomCard>
                </div>
              </>
            )}
          </Card>
        </Column>
      </Row>
      <div className="col-md-12 col-sm-12 col-12 mb-3 text-end mt-1">
        <button
          className="btn print-btn btn--outline fs-7 lh-1"
          type="button"
          // onClick={() => resetFilter()}
        >
          <span className="align-middle">{t("-1", "Cancel")}</span>
          <i className="fas fa-arrow-rotate-left ms-2 mt-1 text-black" />
        </button>
        <button
          className="btn print-btn btn--primary rounded-0 fs-7 lh-1 ms-1"
          type="button"
          onClick={() => {
            if (expertChange === "yes") {
              reopenFormByKey("ETS1234567");
            }
            if (securityStatusChange === "yes") {
              reopenFormByKey("SCF1234567");
            }
          }}
        >
          {/* <i className="fas fa-search" /> */}
          <span className="align-middle">{`${t("-1", "Submit")}`}</span>
          <i className="fas fa-chevron-right  ms-2 mt-1 text-white" />
        </button>
      </div>
    </div>
  );
}
